<div id="breadcrumb-navigation" class="breadcrumb">
  {{ labels.administration }}
  <a
    id="modalidades-seleccion-breadcrumb-link"
    class="breadcrumb-link selected"
    [routerLink]="['/wapi/admin/modalidades-seleccion']"
  >
    &nbsp;>&nbsp;{{ labels.modalidadesSeleccion }}
  </a>
</div>

<br /><br />

<div id="modalidades-seleccion-main-container" class="container">
  <mat-card id="modalidades-seleccion-card">
    <div id="modalidades-seleccion-header" class="header-options">
      <div id="modalidades-seleccion-title" class="title">
        <div class="title-wrapper">
          <h1 class="main-title">{{ labels.modalidadesSeleccion }}</h1>
        </div>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          class="filter-button"
          (click)="toggleSearch()"
          matTooltip="Filtro"
        >
          <mat-icon>filter_list</mat-icon>
          FILTRO
        </button>
        <button
          mat-raised-button
          color="primary"
          class="create-button"
          (click)="openCreateModal()"
          matTooltip="{{ labels.createModalidadSeleccion }}"
        >
          <mat-icon>add</mat-icon>
          {{ labels.createModalidadSeleccion }}
        </button>
      </div>
    </div>

    <!-- Search Panel -->
    @if (showSearchPanel) {
      <div class="search-panel">
        <div class="filters-grid">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar modalidades de selección</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              (input)="searchModalidadesSeleccion($any($event.target).value)"
              placeholder="Buscar por código o características..."
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- Column filters -->
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Código</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.codigo"
              (input)="onColumnFilterChange('codigo', $any($event.target).value)"
              placeholder="Filtrar por código..."
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Estado (activo/inactivo)</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.status"
              (input)="onColumnFilterChange('status', $any($event.target).value)"
              placeholder="Filtrar por estado..."
            />
          </mat-form-field>
        </div>
        <button
          mat-stroked-button
          color="primary"
          (click)="resetFilters()"
          style="height: 40px; align-self: center"
        >
          <mat-icon style="margin-right: 6px">filter_alt_off</mat-icon>
          Limpiar filtros
        </button>
      </div>
    }

    <div id="modalidades-seleccion-table-section" class="table-container">
      @if (loading$ | async) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>{{ labels.loadingModalidadesSeleccion }}</p>
        </div>
      } @else if (error$ | async) {
        <div class="error-container">
          <p class="error-message">{{ error$ | async }}</p>
          <button mat-raised-button color="primary" (click)="loadModalidadesSeleccion()">
            Retry
          </button>
        </div>
      } @else {
        @if (dataSource.data.length > 0) {
          <div class="table-wrapper">
            <table
              id="modalidades-seleccion-table"
              mat-table
              [dataSource]="dataSource"
              [trackBy]="trackByModalidadId"
              class="mat-elevation-z8 full-width-table styled-table"
              matSort
            >
              <!-- ID Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableId }}</th>
                <td mat-cell *matCellDef="let element">{{ element.modalidadSelId }}</td>
              </ng-container>

              <!-- Code Column -->
              <ng-container matColumnDef="codigo">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableCodigo }}</th>
                <td mat-cell *matCellDef="let element">{{ element.codigo }}</td>
              </ng-container>

              <!-- Caracteristicas Column -->
              <ng-container matColumnDef="caracteristicas">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableCaracteristicas }}</th>
                <td mat-cell *matCellDef="let element">{{ element.caracteristicas }}</td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableStatus }}</th>
                <td mat-cell *matCellDef="let element">
                  <span [class]="element.estado ? 'status-active' : 'status-inactive'">
                    {{ element.estado ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableActions }}</th>
                <td mat-cell *matCellDef="let element">
                  <div class="action-buttons">
                    <button
                      mat-icon-button
                      class="view-button"
                      matTooltip="{{ labels.tooltipView }}"
                      (click)="viewDetail(element, false)"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      class="edit-button"
                      matTooltip="{{ labels.tooltipEdit }}"
                      (click)="openCreateModal(element)"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      class="toggle-button"
                      [matTooltip]="element.estado ? 'Desactivar' : 'Activar'"
                      (click)="toggleModalidadSeleccionStatus(element)"
                    >
                      <mat-icon>{{ element.estado ? 'toggle_on' : 'toggle_off' }}</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: tableColumns"
                class="modalidad-seleccion-row"
              ></tr>
            </table>

            <!-- Paginador -->
            <mat-paginator
              #paginator
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              [showFirstLastButtons]="true"
              (page)="onPageChange()"
              aria-label="Seleccionar página de modalidades de selección"
            >
            </mat-paginator>
          </div>
        } @else {
          <div class="no-data-container">
            <mat-icon class="no-data-icon">inbox</mat-icon>
            <p>{{ labels.noModalidadesSeleccion }}</p>
            <button mat-raised-button color="primary" (click)="openCreateModal()">
              {{ labels.createModalidadSeleccion }}
            </button>
          </div>
        }
      }
    </div>
  </mat-card>
</div>

<ng-template #createModalidadSeleccionModal>
  <h2 id="modalidad-seleccion-modal-title" mat-dialog-title>
    {{ isEditing ? labels.editModalidadSeleccion : labels.createModalidadSeleccion }}
  </h2>

  <mat-dialog-content id="modalidad-seleccion-modal-content" class="modal-content">
    <form id="modalidad-seleccion-form" [formGroup]="modalidadSeleccionForm">
      <!-- ID Field (solo para edición) -->
      @if (isEditing && editingModalidadSeleccion) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.modalidadSelId }}</mat-label>
          <input matInput [value]="editingModalidadSeleccion.modalidadSelId" readonly />
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>
      }

      <!-- Code Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.codigo }}</mat-label>
        <input
          matInput
          formControlName="codigo"
          placeholder="Ingrese el código"
          [class.error-field]="hasError('codigo')"
        />
        @if (hasError('codigo')) {
          <mat-error>{{ getErrorMessage('codigo') }}</mat-error>
        }
      </mat-form-field>

      <!-- Caracteristicas Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.caracteristicas }}</mat-label>
        <textarea
          matInput
          formControlName="caracteristicas"
          placeholder="Ingrese las características"
          rows="3"
          [class.error-field]="hasError('caracteristicas')"
        ></textarea>
        @if (hasError('caracteristicas')) {
          <mat-error>{{ getErrorMessage('caracteristicas') }}</mat-error>
        }
      </mat-form-field>

      <!-- Status Field -->
      <div class="status-field">
        <mat-slide-toggle formControlName="estado" color="primary">
          {{ labels.estado }}
        </mat-slide-toggle>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions id="modalidad-seleccion-modal-actions" align="end">
    <button
      id="save-modalidad-seleccion-button"
      mat-button
      mat-raised-button
      color="primary"
      (click)="saveModalidadSeleccion()"
      [disabled]="modalidadSeleccionForm.invalid"
    >
      <mat-icon>save</mat-icon>
      {{ labels.save }}
    </button>
    <button id="cancel-modalidad-seleccion-button" mat-button (click)="closeModal()">
      {{ labels.cancel }}
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #detailModal>
  <div class="detail-modal-container">
    <!-- Header -->
    <div class="detail-modal-header">
      <h2 id="detail-modal-title" mat-dialog-title>Detalle de Modalidad de Selección</h2>
    </div>

    <!-- Content -->
    <mat-dialog-content id="detail-modal-content" class="detail-modal-content">
      <div class="detail-info">
        <div class="detail-row">
          <span class="detail-label">ID:</span>
          <span class="detail-value">{{ detailBeingViewed?.modalidadSelId }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Código:</span>
          <span class="detail-value code-value">{{ detailBeingViewed?.codigo }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Características:</span>
          <span class="detail-value">{{ detailBeingViewed?.caracteristicas }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Estado:</span>
          <span class="detail-value">
            <span
              class="status-badge"
              [class]="detailBeingViewed?.estado ? 'status-active' : 'status-inactive'"
            >
              {{ detailBeingViewed?.estado ? 'Activo' : 'Inactivo' }}
            </span>
          </span>
        </div>
      </div>
    </mat-dialog-content>

    <!-- Actions -->
    <mat-dialog-actions id="detail-modal-actions" align="end" class="detail-modal-actions">
      <button id="close-detail-button" mat-button mat-dialog-close class="close-detail-button">
        {{ labels.close }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
